import { createContext, useCallback, useContext, useMemo, useState } from "react";

const AdminDataRefreshContext = createContext(null);
const INITIAL_VERSIONS = { complexes: 0, sip: 0, transfers: 0 };

export function AdminDataRefreshProvider({ children }) {
  const [versions, setVersions] = useState(INITIAL_VERSIONS);

  const invalidate = useCallback((sectionIds) => {
    const uniqueIds = new Set(sectionIds);
    setVersions((current) => {
      const next = { ...current };
      uniqueIds.forEach((sectionId) => {
        if (Object.prototype.hasOwnProperty.call(next, sectionId)) {
          next[sectionId] += 1;
        }
      });
      return next;
    });
  }, []);

  const value = useMemo(() => ({ versions, invalidate }), [invalidate, versions]);
  return <AdminDataRefreshContext.Provider value={value}>{children}</AdminDataRefreshContext.Provider>;
}

export function useAdminDataRefresh() {
  const value = useContext(AdminDataRefreshContext);
  if (!value) throw new Error("useAdminDataRefresh must be used inside AdminDataRefreshProvider");
  return value;
}
